// extracted by mini-css-extract-plugin
module.exports = {"workTime":"_02712f2b3b--workTime--dh3w7"};